"use client";

import React from "react";
import { InfiniteMovingCards } from "@/components/ui/infinite-moving-cards";
import { Award, CircleFadingArrowUp, Cog, MessageCircleCode, ServerCog, ToolCase, Workflow, Sparkles, BarChart3, Building2, GitFork, Plug2, PlayCircle, ArrowUpFromLine, Link2, Database, CreditCard, ShoppingCart, UploadCloud
 } from "lucide-react"

export default function InfiniteMovingCardsDemo() {
  return (
    <>
      <div className="h-[40px] w-full bg-[#511549f5]"></div>
    <div
        className="h-fit flex flex-col antialiased bg-[#511549f5] dark:bg-black dark:bg-grid-white/[0.05] items-center justify-center relative overflow-hidden">
        <InfiniteMovingCards items={testimonials} direction="left" speed="medium" />
        <InfiniteMovingCards items={testimonials2} direction="right" speed="medium" />
        <InfiniteMovingCards items={testimonials3} direction="left" speed="medium" />
    </div>
      <div className="h-[40px] w-full bg-[#511549f5]"></div>
    </>
  );
}

const testimonials = [
  {
    title: "Implementation & Setup",
    icon: <Cog />
  },
  {
    title: "Customization & Development",
    icon: <MessageCircleCode />
  },
  {
    title: "Integration Services",
    icon: <Workflow />
  },
  {
    title: "Migration & Upgrade",
    icon: <CircleFadingArrowUp />
  },
  {
    title: "Support & Maintenance",
    icon: <ToolCase />
  },
  {
    title: "Training & Consultation",
    icon: <Award />
  },
  {
    title: "Specialized Solutions",
    icon: <ServerCog />
  },
];

const testimonials2 = [
  {
    title: "UI/UX Enhancements",
    // Icon changed to Sparkles to represent an enhancement or polish
    icon: <Sparkles />
  },
  {
    title: "Report & Dashboard Customization",
    // Icon changed to BarChart3 to represent charts and data
    icon: <BarChart3 />
  },
  {
    title: "Industry-Specific Solutions",
    // Icon changed to Building2 to represent a business or industry
    icon: <Building2 />
  },
  {
    title: "Business Process Mapping & Consultation",
    // Icon changed to GitFork to represent branching processes and workflows
    icon: <GitFork />
  },
  {
    title: "Odoo ERP End-to-End Implementation",
    // Toolcase is a good fit for a comprehensive implementation service
    icon: <ToolCase />
  },
  {
    title: "IoT, WhatsApp, and VoIP Integration",
    // Icon changed to Plug2 to clearly represent integration
    icon: <Plug2 />
  },
  {
    title: "Workflow Automation & Business Logic",
    // Icon changed to PlayCircle to symbolize a running, automated workflow
    icon: <PlayCircle />
  },
];

// Testimonials for technical and system-level services
const testimonials3 = [
  {
    title: "Server Migration & Optimization",
    // Icon changed to Database to represent server and data management
    icon: <Database />
  },
  {
    title: "Odoo Version Upgrades",
    // Icon changed to ArrowUpFromLine to clearly indicate an upgrade or lift
    icon: <ArrowUpFromLine />
  },
  {
    title: "Legacy System Integration",
    // Icon changed to Link2 to represent connecting different systems
    icon: <Link2 />
  },
  {
    title: "CRM, Accounting & HRM Integration",
    // Icon changed to Plug2 to represent integration
    icon: <Plug2 />
  },
  {
    title: "Payment Gateway Integration",
    // Icon changed to CreditCard to specifically represent payment gateways
    icon: <CreditCard />
  },
  {
    title: "E-commerce Platform Integration",
    // Icon changed to ShoppingCart to represent an e-commerce platform
    icon: <ShoppingCart />
  },
  {
    title: "Data Migration from Legacy Systems",
    // Icon changed to UploadCloud to symbolize moving data between systems
    icon: <UploadCloud />
  },
];